import { gql } from '@apollo/client'
import { RECRUITER_FRAGMENT } from '../apollo.fragment'

export const SIGNIN_SALESFORCE_RECRUITER_MUTATION = gql`
	mutation signInSalesforceRecruiter($jwtToken: String!, $companyId: String!) {
		signInSalesforceRecruiter(jwtToken: $jwtToken, companyId: $companyId) {
			authToken
			notificationChannel
			recruiter {
				...recruiterFragment
			}
		}
	}

	${RECRUITER_FRAGMENT}
`

export const SIGNIN_RECRUITER_WITH_SALESFORCE_MUTATION = gql`
	mutation signInRecruiterWithSalesforce($companyId: String!, $code: String!, $codeVerifier: String!) {
		signInRecruiterWithSalesforce(companyId: $companyId, code: $code, codeVerifier: $codeVerifier) {
			authToken
			notificationChannel
			recruiter {
				...recruiterFragment
			}
		}
	}

	${RECRUITER_FRAGMENT}
`

export const SIGNOUT_RECRUITER_MUTATION = gql`
	mutation signOutRecruiter {
		signOutRecruiter {
			success
		}
	}
`

export const CREATE_CANDIDATE_IMPERSONATION_GRANT_MUTATION = gql`
	mutation recruiterCreateCandidateImpersonationGrant($workerId: String!) {
		recruiterCreateCandidateImpersonationGrant(workerId: $workerId) {
			grant
			expiresAt
			mode
		}
	}
`
